import store from '@/store'
import {FIX_PAGE, SHOW_GLOBAL_LOADER,} from "@/store/mutation-types";

export function globalLoader(state) {
    store.commit(`system/${SHOW_GLOBAL_LOADER}`, state)
}

export function fixPage(state) {
    store.commit(`system/${FIX_PAGE}`, state)
}

export const isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i) ? true : false;
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i) ? true : false;
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i) ? true : false;
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i) ? true : false;
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows());
    }
};
